"use client";

import { c as _c } from "react/compiler-runtime";
import { ChangeEvent } from "react";
interface AudioPlayerProgressProps {
  currentTime: number;
  duration: number;
  audioUrl: string | null;
  onSeek: (time: number) => void;
  onDragStart: () => void;
  onDragEnd: () => void;
}
function formatTime(seconds: number) {
  if (isNaN(seconds) || seconds < 0) return "0:00";
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${s.toString().padStart(2, "0")}`;
}
export function AudioPlayerProgress(t0) {
  const $ = _c(29);
  const {
    currentTime,
    duration,
    audioUrl,
    onSeek,
    onDragStart,
    onDragEnd
  } = t0;
  const progressPercent = duration > 0 ? currentTime / duration * 100 : 0;
  let t1;
  if ($[0] !== onSeek) {
    t1 = e => {
      onSeek(parseFloat(e.target.value));
    };
    $[0] = onSeek;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChange = t1;
  let t2;
  if ($[2] !== currentTime) {
    t2 = formatTime(currentTime);
    $[2] = currentTime;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <span className="w-10 text-right tabular-nums tracking-tight">{t2}</span>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `${progressPercent}%`;
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="absolute inset-y-0 left-0 right-0 m-auto h-1.5 bg-slate-200 dark:bg-slate-800 rounded-full overflow-hidden pointer-events-none"><div className="h-full bg-primary transition-all duration-75 ease-linear" style={{
        width: t4
      }} /></div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = duration || 100;
  const t7 = !audioUrl;
  let t8;
  if ($[8] !== currentTime || $[9] !== handleChange || $[10] !== onDragEnd || $[11] !== onDragStart || $[12] !== t6 || $[13] !== t7) {
    t8 = <input type="range" min={0} max={t6} value={currentTime} onChange={handleChange} onMouseDown={onDragStart} onMouseUp={onDragEnd} onTouchStart={onDragStart} onTouchEnd={onDragEnd} className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10" disabled={t7} aria-label="Seek chapter audio" />;
    $[8] = currentTime;
    $[9] = handleChange;
    $[10] = onDragEnd;
    $[11] = onDragStart;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = `calc(${progressPercent}% - 6px)`;
  let t10;
  if ($[15] !== t9) {
    t10 = <div className="absolute top-1/2 -translate-y-1/2 min-w-3 min-h-3 w-3 h-3 rounded-full bg-primary shadow-sm shadow-primary/50 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" style={{
      left: t9
    }} />;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t5 || $[19] !== t8) {
    t11 = <div className="relative flex-1 group h-5 flex items-center cursor-pointer">{t5}{t8}{t10}</div>;
    $[17] = t10;
    $[18] = t5;
    $[19] = t8;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== duration) {
    t12 = formatTime(duration);
    $[21] = duration;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12) {
    t13 = <span className="w-10 tabular-nums tracking-tight">{t12}</span>;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t11 || $[26] !== t13 || $[27] !== t3) {
    t14 = <div className="flex items-center gap-3 text-xs font-medium text-slate-500 dark:text-slate-400">{t3}{t11}{t13}</div>;
    $[25] = t11;
    $[26] = t13;
    $[27] = t3;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
}